export default "__VITE_ASSET__CoiC8AwV__"